import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import { cognitoUserPool, logout } from "../Constants/cognito"
import { useSnackbar } from 'notistack';
import { Box, IconButton } from "@mui/material"
import Grid from "@mui/material/Grid2"
import CloseIcon from '@mui/icons-material/Close';
import QRCode from 'react-qr-code';

export default function ConfigureMFA({
    open,
    secretCode,
    closeModal,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [token, setToken] = React.useState("")

    const update_mfa = () => {
        const user = cognitoUserPool.getCurrentUser()
        if (user != null) {
            user.getSession((err, session) => {
                if (err) {
                    logout()
                    return;
                }
                user.setSignInUserSession(session)
                user.verifySoftwareToken(token, 'device', {
                    onSuccess: (result) => {
                        var totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true,
                        };
                        user.setUserMfaPreference(null, totpMfaSettings, function(err, result) {
                            if (err) {
                                alert(err.message || JSON.stringify(err));
                            }else {
                                enqueueSnackbar("MFA Updated Successfully", { variant: 'success' })
                                closeModal(true)
                            }
                            console.log('MFA call result ' + result);
                        });
                    },
                    onFailure: (err) => {
                        enqueueSnackbar("MFA failed to update", { variant: 'error' })
                    }
                })
            })
        } else {
            logout();
            return
        }
    }

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                maxWidth='md'
            >
                <DialogTitle>
                    {"Configure MFA"}
                    <IconButton
                        aria-label="close"
                        onClick={() => closeModal(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 3,
                            pt: '13px',
                            textAlign: 'center'
                        }}
                    >
                        <Box><span>To add MFA, go to your authenticator app of choice (Microsoft Authenticator, Google Authenticator, etc..) and scan the QR code to add a new "Other" account. Afterwards, type in the code generated by your MFA app.</span></Box>
                        <QRCode
                            key={secretCode}
                            title="MFA Code"
                            value={secretCode ?? 'test'}
                            bgColor="#FFFFFF"
                            fgcolor="#000000"
                            size={256}
                        />
                        <TextField
                            label="MFA Token"
                            type={'text'}
                            value={token}
                            onChange={(e) => setToken(e.target.value)}
                            sx={{maxWidth: '300px'}}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 10px 10px 30px" }}>
                        <Grid size="auto">
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" autoFocus onClick={update_mfa}>
                                Update MFA
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>)
    );
}
